<template>
    <div class="bg-gray-800 py-8 px-4 md:p-24 m-0 bg-jackpot" id="horses">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
            <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-1">
                <div>
                    <div>
                        <span class="h-12 w-12 rounded-md flex items-center justify-center bg-racing-stars-yellow">
                            <CursorClickIcon class="h-6 w-6 text-white text-gray-800" aria-hidden="true" />
                        </span>
                    </div>
                    <div class="mt-6">
                        <h2 class="text-3xl font-extrabold tracking-tight text-white">
                            Pick Your Horses
                        </h2>
                        <p class="mt-4 text-lg text-gray-500 text-white">
                            Examine the form, odds, jockey info, and various other stats for each horse, and select one horse from each race of the day to create your winning lineup.
                        </p>
                        <div class="mt-6">
                            <a href="/register" class="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm hover:opacity-80 bg-racing-stars-yellow text-gray-800">
                                Sign Up
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-12 sm:mt-16 lg:mt-0">
                    <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                        <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-3/4 lg:w-auto lg:max-w-none mt-5" :src="asset('images/meeting_desktop_open.png')" alt="Purchasing tokens" />
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import { DatabaseIcon, CursorClickIcon } from '@heroicons/vue/outline'

export default {
    components: {
        DatabaseIcon,
        CursorClickIcon,
    }
}

</script>
